import React from 'react';

const SvgLk = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="LK_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="LK_svg__b" fill="#fff">
        <use xlinkHref="#LK_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#LK_svg__a" />
      <path fill="#FFBF19" mask="url(#LK_svg__b)" d="M0 0h28v20H0z" />
      <path
        d="M10.667 1.333H25.33c.738 0 1.337.597 1.337 1.332v14.67c0 .736-.589 1.332-1.337 1.332H10.667V1.333z"
        fill="#A52531"
        mask="url(#LK_svg__b)"
      />
      <path
        d="M1.333 2.665c0-.736.59-1.332 1.332-1.332h2.668v17.334H2.665a1.332 1.332 0 0 1-1.332-1.332V2.665z"
        fill="#03664F"
        mask="url(#LK_svg__b)"
      />
      <rect
        fill="#FF6816"
        mask="url(#LK_svg__b)"
        x={5.333}
        y={1.333}
        width={4}
        height={17.333}
        rx={0.667}
      />
      <path
        d="M12.667 4A.667.667 0 0 1 12 3.333v-.666h.667a.667.667 0 0 1 0 1.333zm12 0a.667.667 0 1 1 0-1.333h.666v.666a.667.667 0 0 1-.666.667zm0 12c.368 0 .666.298.666.667v.666h-.666a.667.667 0 1 1 0-1.333zm-12 0a.667.667 0 0 1 0 1.333H12v-.666c0-.369.298-.667.667-.667zM16 12.667a.669.669 0 0 0-.667-.667H16c-.368 0-.945-.101-1.289-.241 0 0-1.378-.426-1.378-1.092 0-.667.264-.807.264-.807.222-.29.293-.797.161-1.148 0 0-.558-1.246-.425-2.045.134-.8.761-.999.761-.999.316-.185.573-.034.573.326v2.679c0 .365.27.795.604.962l.125.063c.333.167.815.091 1.074-.168l-.274.274c.26-.26.2-.606-.134-.773l-.729-.364V8H16c.368 0 .397-.135.062-.302l-.729-.365v-.666H16c.368 0 .878-.211 1.137-.47l-.274.273C17.123 6.21 17.63 6 18 6c.368 0 .802.27.969.604l.062.125c.167.334.21.882.091 1.237l-.244.735c-.117.349.096.632.463.632h1.984c.373 0 .886-.21 1.145-.47l-.274.274c.26-.26.2-.605-.134-.772l-.124-.063A3.36 3.36 0 0 0 20.667 8 .665.665 0 0 1 20 7.333c0-.368.21-.877.47-1.137L20.667 6v.667c0 .368.302.666.666.666h-.666H22c.368 0 .802.27.969.605l.062.124c.167.334.329.898.352 1.264 0 0 .092.634-.05 1.34-.14.707-.301.786-.301.786-.202.302-.365.854-.365 1.22v1.322a.668.668 0 0 1-.667.673c-.368 0-.532-.27-.365-.605l.063-.124c.167-.334.167-.874 0-1.209l-.063-.125c-.166-.333-.302-.308-.302.063 0 .368-.135.936-.302 1.27l-.062.125c-.167.334-.598.605-.969.605-.368 0-.532-.27-.365-.605l.063-.124c.167-.334.302-.9.302-1.271a.673.673 0 0 0-.673-.667h-1.32a.668.668 0 0 0-.674.667c0 .368-.135.936-.302 1.27l-.062.125c-.167.334-.598.605-.969.605-.368 0-.532-.27-.365-.605l.063-.124c.167-.334.302-.9.302-1.271z"
        fill="#FFBF18"
        mask="url(#LK_svg__b)"
      />
    </g>
  </svg>
);

export default SvgLk;
